import { Component, inject, input, output, type Signal } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { type ChildClient, UserRolesIds } from '@models';
import { Store } from '@ngrx/store';
import { AuthSelectors, ClientManagementActions } from '@ngrx-store';

@Component({
  imports: [MatSlideToggleModule, MatTooltip],
  selector: 'avs-two-way-communication',
  templateUrl: './two-way-communication.html',
})
export class TwoWayCommunicationComponent {
  client = input<ChildClient>();
  value = input(false);
  changed = output<boolean>();

  protected eUserRolesIds = UserRolesIds;
  protected userRole: Signal<UserRolesIds>;

  private store = inject(Store);

  constructor() {
    this.userRole = this.store.selectSignal(AuthSelectors.userRole);
  }

  protected onUpdate(twoWayCommunication: boolean) {
    const client = this.client();

    if (client) {
      this.store.dispatch(ClientManagementActions.updateChildClient({ clientClientId: client.id, clientData: { twoWayCommunication } }));

      return;
    }

    this.changed.emit(twoWayCommunication);
  }
}
